const clean = (value) => String(value || '').trim();

/**
 * The name to show for a trip participant.
 * Prefer a real first+last name (clients). Partner contact names only overlay
 * agency stand-in accounts that typically have a company first_name and no last_name.
 */
export const getParticipantDisplayName = (participant) => {
  if (!participant) return '';

  const first = clean(participant.first_name);
  const last = clean(participant.last_name);
  if (first && last) return `${first} ${last}`;

  const partnerName = clean(participant.partner_display_name);
  if (partnerName) return partnerName;

  if (first) return first;
  return clean(participant.username) || clean(participant.email).split('@')[0] || '';
};

export default getParticipantDisplayName;
